import { render, staticRenderFns } from "./ContractInfoCard.vue?vue&type=template&id=3f5c3080&scoped=true"
import script from "./ContractInfoCard.vue?vue&type=script&lang=js"
export * from "./ContractInfoCard.vue?vue&type=script&lang=js"
import style0 from "./ContractInfoCard.vue?vue&type=style&index=0&id=3f5c3080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5c3080",
  null
  
)

export default component.exports